export const RESET_DASHBOARD_DATA = 'RESET_DASHBOARD_DATA';

export const DASHBOARD_DATA_READY = 'DASHBOARD_DATA_READY';

export const UPDATE_WIDGET = 'UPDATE_WIDGET';
